import { api, ApiResponse } from './api'
import {
  User,
  LoginResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  UpdateProfileRequest,
  GitHubAuthResponse,
  GitHubCallbackResponse,
  GitHubSelectOrgRequest,
} from '@/types'

export const authService = {
  async refresh(data: RefreshTokenRequest): Promise<RefreshTokenResponse> {
    const response = await api.post<ApiResponse<RefreshTokenResponse>>('/auth/refresh', data)
    return response.data.data
  },

  async getMe(): Promise<User> {
    const response = await api.get<ApiResponse<User>>('/auth/me')
    return response.data.data
  },

  async updateProfile(data: UpdateProfileRequest): Promise<User> {
    const response = await api.put<ApiResponse<User>>('/users/me', data)
    return response.data.data
  },

  async getGitHubAuthUrl(): Promise<GitHubAuthResponse> {
    const response = await api.get<ApiResponse<GitHubAuthResponse>>('/auth/github')
    return response.data.data
  },

  async handleGitHubCallback(code: string, state: string): Promise<GitHubCallbackResponse> {
    const response = await api.post<ApiResponse<GitHubCallbackResponse>>('/auth/github/callback', {
      code,
      state,
    })
    return response.data.data
  },

  async selectGitHubOrg(data: GitHubSelectOrgRequest): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>('/auth/github/select-org', data)
    return response.data.data
  },
}
